<script>
   import { Router, Link, Route } from "svelte-routing";

   // Pages
   import HomePage from "./HomePage.svelte"
   import BoatsPage from "./BoatsPage.svelte"
   import PortPage from "./PortPage.svelte"

   export let url = ""; // Used by routing lib!

//	export let port;
   //let port = "";
      

  // <h4>Aktivitet:</h4>
  // <div>
  //    Someone left
  // </div>
</script>

  <header>
      <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <a class="navbar-brand" href="/">Havne.info</a>
      </nav>
    </header>

<main role="main" style="background-color: lightgray">
<Router url="{url}">
  <!-- <nav>
    <Link to="/">Home</Link>
    <Link to="port/4160/judaberg">port</Link>
    <Link to="boat/blond">Boats</Link>
  </nav> -->
  <div>
     <Route path="boat/:id" component="{BoatsPage}" /> 
     <Route path="port/:postnr/:port" component="{PortPage}" /> 
     <Route path="/"><HomePage /></Route>
  </div>
</Router>
</main>
